import { Feature } from "ol";
import WKT from "ol/format/WKT";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
	createShape,
	deleteShape,
	updateShape,
} from "../../../../../actions/form";

export function useAPI(activeId: string, qid: string) {
	const dispatch = useDispatch();

	const updateShapesInDB = useCallback(
		(features: Feature[]) => {
			const format = new WKT();
			for (let feature of features) {
				const wkt = format.writeFeature(feature, {
					dataProjection: "EPSG:4326",
					featureProjection: "EPSG:3857",
				});
				const identifier = feature.get("identifier") ?? feature.getId();
				if (identifier) {
					dispatch(updateShape(activeId, qid, String(identifier), wkt));
				} else {
					dispatch(createShape(activeId, qid, wkt));
				}
			}
		},
		[activeId, qid],
	);

	const deleteShapeInDB = useCallback(
		(identifier: string) => {
			dispatch(deleteShape(activeId, qid, identifier));
		},
		[activeId, qid],
	);

	return {
		updateShapesInDB,
		deleteShapeInDB,
	};
}
